export const getPeriodLabel = (value: number) => {
    const MINUTE = 60;
    if (value < MINUTE) return `${value}s`;
    return `${value / MINUTE}m`;
};
